export type VisibilityState = Record<string, boolean>;
export const columnVisibilityItems:VisibilityState  = {
    // email:false
}